import { AbsoluteContainer, AppText, FlexColumn } from "src/style"
import {ReactComponent as WelcomeImg} from 'src/assets/img/welcome-asset.svg'
import {ReactComponent as Logo} from 'src/assets/img/crendly-logo-white.svg'


export const WelcomeFrame = () => {
    return (
        <FlexColumn 
            minHeight='100' mnHUnit='%' width='37'
            sizeUnit='%' radius='0.8' bgColor='#4C6FFF'
            className='welcome-container'
        >
            <AbsoluteContainer top='3' left='2.5'>
                <Logo />
            </AbsoluteContainer>
            <WelcomeImg className='welcome-img'/>
            <AppText 
                textSize='3.8' color='#ffffff' fontWeight='700'
                lineHeight='4' topMargin='8' width='70' sizeUnit='%'
                leftPadding='2' rightPadding='2'
                className='welcome-text'
            >
                Welcome to Crendly Support Panel
            </AppText>
        </FlexColumn>
    )
} 